import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ReachOutToTheShop from "./sections/ReachOutToTheShop";
import FindUsHere from "./sections/FindUsHere";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ReachOutToTheShop />
      <FindUsHere />
      <Footer />
    </div>;
}